<div class="bills-transactions-container">
  <p-toast></p-toast>
  
  <div class="bills-transactions-header">
    <button type="button" class="back-button" (click)="goBack()">
      <i class="pi pi-arrow-left"></i>
      <span>Back</span>
    </button>
    <h1 class="page-title">Bills Transactions</h1>
  </div>

  @if (isLoading()) {
    <div class="loading-container">
      <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
      <p class="loading-text">Loading bills payments...</p>
    </div>
  } @else if (error()) {
    <div class="error-container">
      <div class="error-icon">
        <i class="pi pi-exclamation-triangle"></i>
      </div>
      <h2 class="error-title">Error Loading Payments</h2>
      <p class="error-message">{{ error() }}</p>
      <button type="button" class="retry-button" (click)="loadPayments(1)">
        <i class="pi pi-refresh"></i>
        <span>Retry</span>
      </button>
    </div>
  } @else if (payments().length === 0) {
    <div class="empty-container">
      <div class="empty-icon">
        <i class="pi pi-receipt"></i>
      </div>
      <h2 class="empty-title">No Bills Payments Yet</h2>
      <p class="empty-message">You haven't made any bills payments yet. Start paying bills to see your transaction history here.</p>
    </div>
  } @else {
    <div class="bills-transactions-content">
      <div class="payments-summary">
        <p class="summary-text">Showing {{ payments().length }} of {{ totalCount() }} bills payments</p>
      </div>

      <div class="payments-list">
        @for (payment of payments(); track payment.id) {
          <div class="payment-card">
            <div class="payment-header">
              <div class="payment-info">
                <div class="payment-icon-wrapper">
                  <i class="pi" [class]="getServiceIcon(payment.service)"></i>
                </div>
                <div class="payment-details-header">
                  <h3 class="payment-service">{{ payment.serviceDisplay || 'Bills Payment' }}</h3>
                  <p class="payment-date">{{ formatDate(payment.createdAt) }}</p>
                </div>
              </div>
              <div class="payment-status-wrapper">
                <span class="payment-status" [class]="getStatusClass(payment.status)">
                  {{ getStatusText(payment.status) }}
                </span>
              </div>
            </div>

            <div class="payment-details">
              <div class="detail-row">
                <span class="detail-label">
                  <i class="pi pi-money-bill"></i>
                  <span>Amount</span>
                </span>
                <span class="detail-value amount">{{ formatPrice(payment.amount) }}</span>
              </div>
              @if (payment.fee > 0) {
                <div class="detail-row">
                  <span class="detail-label">
                    <i class="pi pi-percentage"></i>
                    <span>Fee</span>
                  </span>
                  <span class="detail-value">{{ formatPrice(payment.fee) }}</span>
                </div>
              }
              <div class="detail-row">
                <span class="detail-label">
                  <i class="pi pi-wallet"></i>
                  <span>Total</span>
                </span>
                <span class="detail-value total">{{ formatPrice(payment.totalAmount) }}</span>
              </div>
              @if (payment.transactionReference) {
                <div class="detail-row">
                  <span class="detail-label">
                    <i class="pi pi-id-card"></i>
                    <span>Transaction Ref</span>
                  </span>
                  <span class="detail-value ref">{{ payment.transactionReference }}</span>
                </div>
              }
              @if (payment.providerReference) {
                <div class="detail-row">
                  <span class="detail-label">
                    <i class="pi pi-building"></i>
                    <span>Provider Ref</span>
                  </span>
                  <span class="detail-value ref">{{ payment.providerReference }}</span>
                </div>
              }
              @if (payment.provider) {
                <div class="detail-row">
                  <span class="detail-label">
                    <i class="pi pi-shopping-bag"></i>
                    <span>Provider</span>
                  </span>
                  <span class="detail-value">{{ payment.provider }}</span>
                </div>
              }
              @if (payment.token) {
                <div class="detail-row token-row" [class.electricity-token]="payment.service && payment.service.toLowerCase().includes('electricity')">
                  <span class="detail-label">
                    <i class="pi pi-key"></i>
                    <span>Token</span>
                  </span>
                  <span class="detail-value token" [class.electricity-token-value]="payment.service && payment.service.toLowerCase().includes('electricity')">{{ payment.token }}</span>
                </div>
              }
            </div>
          </div>
        }
      </div>

      @if (totalPages() > 1) {
        <div class="pagination">
          <button 
            type="button" 
            class="pagination-btn" 
            [disabled]="currentPage() === 1"
            (click)="previousPage()">
            <i class="pi pi-chevron-left"></i>
            <span>Previous</span>
          </button>
          
          <div class="page-numbers">
            @for (page of getPageNumbers(); track page) {
              <button 
                type="button"
                class="page-number"
                [class.active]="currentPage() === page"
                (click)="goToPage(page)">
                {{ page }}
              </button>
            }
          </div>

          <button 
            type="button" 
            class="pagination-btn"
            [disabled]="currentPage() === totalPages()"
            (click)="nextPage()">
            <span>Next</span>
            <i class="pi pi-chevron-right"></i>
          </button>
        </div>
      }
    </div>
  }
</div>
